import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import {
    createFieldDate,
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import {
    createColumnDatetime,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { callRequestStatus } from "../../storage-location/request/request.section";
import { callMainOperation } from "./haz-discuss-info/haz-discuss-info.section";
import { defineAsyncComponent } from "vue";
import { callUser } from "../../storage-location/request/requestor/requestor.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { 
        group: "REQUEST_TYPE", 
        value: searchQuery,
        where: [
            { name: "key", type: "String", operator: "in", value: ["1", "2", "4"] }
        ]
    });
export const callHazDiscussAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_DISCUSS_ATTACHMENT", value: searchQuery })
        .then(d => lodash.orderBy(d, ['attribute.isRequiredAttachment', 'seq'], ['desc', 'asc']));
export const callHazDiscuss = ({ searchQuery, userInfo, isOfficerCreate }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }

    return store
        .dispatch("resource/v1/transaction/hazDiscuss/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHazDiscussFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/hazDiscuss/search", {
            criteria: {
                isDistinct: true,
                select: ["**", "refUserCompany.refPersonType.*", "refUser.refPersonType.*"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "mainSubStances",
                        select: ["**", "refSubStance.**"],
                        page: 0,
                        size: 1000000,
                        children: [
                            {
                                name: "pictograms",
                                select: ["*", "refPictogram.**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            },
                        ],
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "aquatics",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "useRates",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "attachments",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = () => {
    const columns = [
        /*createColumnInput({
            title: () => i18n.global.t("model.hazDiscuss.refUserCompany"),
            dataIndex: "refDiscussHazDiscussTemp.refUserCompany.companyNameTh",
            customRender: ({ record }) => {
                if (record.refHazDiscussTemp?.refUserCompany?.refPersonType?.key === "1") {
                    return <div>{record.refHazDiscussTemp?.refUserCompany?.companyNameTh}</div>;
                }
                return <div>{record.refHazDiscussTemp?.refUserCompany?.fullNameTh}</div>;
            }
        }),*/
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refHazDiscuss.approveCode",
            align: "center"
        }),
        createColumnDatetime({
            title: () => i18n.global.t("views.request.waitReceiveStatusDate"),
            dataIndex: "refWaitReceiveStatus.statusDatetime",
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazDiscuss.tradeNameTh"), 
            dataIndex: "refHazDiscussTemp.tradeNameTh", 
            align: "center" 
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refMainOperation"),
            dataIndex: "refHazDiscussTemp.refMainOperation.value",
            customRender: ({ record }) => <div>{record.refHazDiscussTemp?.refMainOperation?.value}</div>,
            inputProp: () => ({ list: callMainOperation, optLabel: "value" }),
            search: { name: "refMainOperation.id" },
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refHazDiscuss
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneHazDiscuss({ model: createForm({ props, data, refs }) });
                                            } else {
                                                cloneHazDiscuss({ model, id: model.refHazDiscuss?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazDiscuss`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refHazDiscuss,
                            "onUpdate:value": value => {
                                const oldValue = model.refHazDiscuss;
                                model.refHazDiscuss = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.hazDiscuss.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneHazDiscuss({ model, id: value?.id }),
                                        onCancel: () => {
                                            model.refHazDiscuss = oldValue;
                                        }
                                    });
                                } else {
                                    cloneHazDiscuss({ model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => 
                                callHazDiscuss({ searchQuery, userInfo: store.state.resource.auth.info?.user, isOfficerCreate: model.isOfficerCreate }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => model.requestCode && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCodeTitle`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => model.refHazDiscuss?.approveCode && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazDiscuss.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazDiscuss?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => model.refHazDiscuss?.effectiveDate && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazDiscuss.effectiveDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.effectiveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazDiscuss?.effectiveDate,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => model.refHazDiscuss?.expireDate && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazDiscuss.expireDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.expireDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazDiscuss?.expireDate,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly || !model.refHazDiscussTemp.refUserCompany,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneHazDiscuss = ({ model, id }) => {
    if (id) {
        callHazDiscussFull({ id }).then(hazDiscuss => {
            const refHazDiscussTemp = copyForm({ form: { ...hazDiscuss, isTemp: true } });
            if (id) {
                refHazDiscussTemp.attachments.forEach((d, index) => (d.refRealId = hazDiscuss.attachments[index].id));
                refHazDiscussTemp.mainSubStances.forEach((d, index) => {
                    d.refReal = { id: hazDiscuss.mainSubStances[index].id };
                });
                refHazDiscussTemp.aquatics.forEach((d, index) => (d.refReal = { id: hazDiscuss.aquatics[index].id }));
                refHazDiscussTemp.useRates.forEach((d, index) => (d.refReal = { id: hazDiscuss.useRates[index].id }));
            }
            return callUser({ userCompanyId: refHazDiscussTemp.refUserCompany.id }).then(users => {
                refHazDiscussTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refHazDiscussTemp.refUser;
                router.push({
                    name: router.currentRoute.value.name,
                    params: { props: JSON.stringify({ form: { ...model, refDepartment: hazDiscuss.refDepartment, refHazDiscussTemp } }) },
                    query: { _timestamp: new Date().getTime() }
                });
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const isOperationAndSubStanceTypeMain = ({ modelRef, operation, subStanceTypeMain, isTechnicalGrade }) => {
    return (
        modelRef.refHazDiscussTemp.refMainOperation?.key === operation &&
        modelRef.refHazDiscussTemp.refSubStanceTypeMain?.key === subStanceTypeMain &&
        (isTechnicalGrade ? modelRef.refHazDiscussTemp.isTechnicalGrade : !modelRef.refHazDiscussTemp.isTechnicalGrade)
    );
};
